/*
 * Copyright 2018-present Evernote Corporation. All rights reserved.
 */

import Broker from 'ion-broker';
import {
  getLoginEndpoint,
  getSSOInitializationEndpoint,
  getLogoutEndpoint,
} from './endpoint';

/**
 * Trigger the Login Flow.
 */
export const triggerLogin = (): void => {
  window.location.assign(getLoginEndpoint());
};

export const triggerLogout = (namespace?: string): void => {
  if (namespace) {
    Broker.call('cupboard.clearNamespace', { namespace });
  }
  window.location.assign(getLogoutEndpoint());
};

/*
 * Precondition: this function is invoked as a result of some user interaction.
 * Return value: https://developer.mozilla.org/en-US/docs/Web/API/Window/open#Return_value
 */
export const triggerSSOFlow = (w: Window): Window | null =>
  w.open(getSSOInitializationEndpoint());
